'use client';
import { List, Typography } from '@mui/material';

import { Box } from '@mui/material';
import { StructuredContentDocument } from '@repo/supergraph/structuredContent/types';
import { useState } from 'react';
import { ShowMore } from '../../../ShowMore';
import { TableOfContentItem } from './TableOfContentItem';
import { TableOfContentsEntry, TableOfContentsEntryType } from './types';

type TOCProps = StructuredContentDocument<{
  title: string;
  entryFilter: TableOfContentsEntryType;
  hasItemMarker: boolean;
  hasNumberPrefix: boolean;
  showMore: boolean;
  numItemsAboveFold: number;
  items: TableOfContentsEntry[];
  autoPopulateItems?: boolean;
}>;

export function TableOfContents({ props }: TOCProps) {
  const {
    title,
    hasItemMarker = false,
    hasNumberPrefix = false,
    showMore = true,
    items = [],
    numItemsAboveFold = 5,
  } = props;
  const [activeItemIndex, setActiveItemIndex] = useState(-1);

  if (items.length === 0) {
    return null;
  }

  const renderToCItems = (
    <List sx={{ padding: 0 }} component={hasNumberPrefix ? 'ol' : 'ul'}>
      {items.map((tocItem, index) => {
        const itemIndex = index + 1;

        return (
          <TableOfContentItem
            key={tocItem.target}
            target={tocItem.target}
            isNumberList={hasNumberPrefix}
            isActiveItem={hasItemMarker && index === activeItemIndex}
            title={tocItem.textContent}
            itemIndex={itemIndex}
            setActiveItem={() => setActiveItemIndex(index)}
          />
        );
      })}
    </List>
  );

  return (
    <Box sx={{ marginY: 3.5 }}>
      <Typography
        variant="smallHeadline"
        sx={{
          textTransform: 'uppercase',
        }}
      >
        {title}
      </Typography>
      <Box sx={{ marginTop: 3 }}>
        {showMore ? (
          <ShowMore
            instanceId="structured-content-toc-show-more"
            showMoreText="Show More"
            showLessText="Hide"
            maxContentHeight={numItemsAboveFold * 40}
            hideBottomGradient
          >
            {renderToCItems}
          </ShowMore>
        ) : (
          renderToCItems
        )}
      </Box>
    </Box>
  );
}
